import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  const [index, setIndex] = useState(0);

  const next = () => setIndex((i) => (i + 1) % testimonials.length);
  const prev = () => setIndex((i) => (i - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            What Clients Say
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Trusted by Owners Who Want Results
          </h2>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 relative rounded-2xl border border-white/10 bg-background-100/70 backdrop-blur p-8 md:p-12">
            <div className="text-center max-w-3xl mx-auto">
              <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                <i className="ri-double-quotes-l text-2xl"></i>
              </span>
              <p className="mt-6 font-heading font-medium text-xl md:text-2xl text-foreground-950 leading-relaxed">
                &ldquo;{testimonials[index].quote}&rdquo;
              </p>
              <div className="mt-6">
                <p className="font-heading font-semibold text-foreground-950">
                  {testimonials[index].name}
                </p>
                <p className="text-sm text-foreground-600">{testimonials[index].role}</p>
              </div>
            </div>

            <div className="mt-8 flex items-center justify-center gap-4">
              <button
                onClick={prev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/10 text-foreground-700 hover:border-primary-500 hover:text-primary-400 transition-colors"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <div className="flex items-center gap-2">
                {testimonials.map((t, i) => (
                  <button
                    key={t.name}
                    onClick={() => setIndex(i)}
                    aria-label={`Testimonial ${i + 1}`}
                    className={`h-1.5 rounded-full transition-all ${
                      i === index ? 'w-6 bg-primary-400' : 'w-1.5 bg-background-300'
                    }`}
                  ></button>
                ))}
              </div>
              <button
                onClick={next}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/10 text-foreground-700 hover:border-primary-500 hover:text-primary-400 transition-colors"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}